import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getCardList() {
    const response = Api().post(apiPath.card + "/list");
    return response;
  },

  getCardDetail(data) {
    const response = Api().post(apiPath.card + "/detail", data);
    return response;
  },

  registerCard(options, data) {
    const response = Api().post(apiPath.card + "/register", data, options);
    return response;
  },

  editCard(options, data) {
    const response = Api().post(apiPath.card + "/modify", data, options);
    return response;
  },

  deleteCard(data) {
    const response = Api().post(apiPath.card + "/delete", data);
    return response;
  },

  sendEbarimt(data) {
    const response = Api().post(apiPath.send_ebarimt, data);
    return response;
  }
};
